import React from 'react'
import ReactDOM from 'react-dom/client'
import SearchContainer from './search'
import { store } from '../../store'
import { Provider } from 'react-redux'

function Wrapper(props) {
  return (
      <Provider store={store}>
          <SearchContainer {...props}/>
      </Provider>
  )
}

function initSearchContainer(element) {
  var options = element.dataset;
  var root = ReactDOM.createRoot(element);
  root.render(React.createElement(Wrapper, options));
}

document.addEventListener("DOMContentLoaded", function() {
  var elements = document.querySelectorAll('[data-search]');
  elements.forEach(initSearchContainer);
});

